// Tiny helper for building query keys under a shared root. All query factory
// files use this so every resource follows one shape:
//
//   const memberTagKey = createQueryKeyFactory("member-tag");
//   memberTagKey.root()              // ["member-tag"]
//   memberTagKey.key("detail", id)   // ["member-tag", "detail", id]
export type QueryKeyPart =
  | string
  | number
  | boolean
  | readonly QueryKeyPart[]
  | Readonly<Record<string, unknown>>;

export function createQueryKeyFactory<TRoot extends string>(root: TRoot) {
  const rootKey = [root] as const;
  return {
    root: () => rootKey,
    key: <TParts extends readonly QueryKeyPart[]>(...parts: TParts) =>
      [root, ...parts] as const,
  };
}
